export const PropertyBookingVoucher = ({ data }) => {

  const guest = data?.Table?.[0] || {};
  const room = data?.Table1?.[0] || {};
  const hotel = data?.Table3?.[0] || {};
  const BookingID = data?.Table4?.[0] || {};

  let bookingComment = "N/A";
  if (guest.BookingComment) {
    try {
      const parsed = JSON.parse(guest.BookingComment);
      if (Array.isArray(parsed) && parsed.length > 0) {
        bookingComment = parsed[0].BookingComment || "N/A";
      }
    } catch (e) {
      console.error("Error parsing BookingComment:", e);
    }
  }
  return (
    <>
      <style>{`
        ul li {
          padding : 2px ;
        }

        .bullet-dote-container{
         width: 10px;
         height: 10px ;
         border-radius: 50% ;
         border: 3px solid #8b949a ;
         display: flex ;
         align-items: center ;
         justify-content: center ;
         margin-top: 5px;
        }
               .bullet-dote-box{
                  width: 5px ;
                  height: 5px ;
                  border-radius: 50% ; 
                  background-color: white ; 
               }
    `}</style>
      <div id="voucher-content" className="text-muted" style={{ fontSize: "12px" }} >
        <div className="bg-white p-4">
          {/* Header */}
          <div className="text-center  mb-1">
            <img
              src="/assets/img/uday-golden_logo.webp"
              alt="Uday Palace Logo"
              style={{ height: "auto", width: "50%" }}
              className="me-3"
            />
          </div>


          {/* Hotel Image */}

          <img
            src="/assets/img/facade-image-1.webp"
            alt="Hotel"
            className="rounded-lg shadow-md "
            style={{ width: "100%", height: "500px" }}
          />
          <h1 className="mt-2 fw-800" style={{ color: "#9b5c0d" }} > Your Booking is Confirmed! </h1>
          <hr />
          {/* <p className="fw-bold" >Booking ID - <span className="font-mono">{BookingID.BONRESID || "N/A"}</span></p> */}

          {/* Booking Details */}
          <div className="row">
            <div className="col-md-5">
              <h6 className="fw-bold" style={{ color: "#9b5c0d" }}> HERE ARE YOUR BOOKING DETAILS: </h6>
              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Confirmation No.</div>
                </div>
                <div className="col-md-5">
                  <div >{BookingID.PMSRESID || "N/A"}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Guest Name</div>
                </div>
                <div className="col-md-5">
                  <div > {guest.FirstName} {guest.LastName}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Booking Date</div>
                </div>
                <div className="col-md-5">
                  <div >{guest.BookingDate || "N/A"}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Room Type</div>
                </div>
                <div className="col-md-5">
                  <div >{room.RoomName}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Meal Plan</div>
                </div>
                <div className="col-md-5">
                  <div >{room.MeelPlan}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Check-In</div>
                </div>
                <div className="col-md-5">
                  <div >{room.CheckInDate}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Check-Out</div>
                </div>
                <div className="col-md-5">
                  <div >{room.CheckOutDate}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Total Night</div>
                </div>
                <div className="col-md-5">
                  <div >{room.Nights}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">No. of Guest</div>
                </div>
                <div className="col-md-5">
                  <div >02</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Room Rate (Per Night)</div>
                </div>
                <div className="col-md-5">
                  <div >₹{room.RoomRate || "N/A"}</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Extra Charges(if any)</div>
                </div>
                <div className="col-md-5">
                  <div >0</div>
                </div>
              </div>

              <div className="row" style={{ borderBottom: "1px solid #D4D3D3" }}>
                <div className="col-md-7">
                  <div className="text-start">Total Amount</div>
                </div>
                <div className="col-md-5">
                  <div >₹{BookingID.TotalAfterTax || "N/A"}</div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div>Notes : {bookingComment || "N/A"}</div>
                </div>
              </div>


            </div>
            <div className="col-md-1"></div>

            {/* Right - Note */}
            <div className="col-md-6">
              <p className="mb-4">
                Dear <strong>{guest.Title} {guest.FirstName} {guest.LastName}</strong>,
              </p>
              <div>
                Thank you for choosing{" "}
                <strong>{hotel.DisplayName},</strong>
              </div>
              <div>
                <strong>a member of Radisson Individuals</strong> for your upcoming stay.
                Your booking is confirmed, there’s no need to reconfirm with the
                hotel or <strong>BookOnNILE</strong>.
              </div>
              <div>
                We look forward to welcoming you and wish you a pleasant visit.
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-3">
            Accommodation charges collected on behalf of hotel (incl. applicable
            taxes).

          </div>
        </div>

        <div className="page-break"></div>

        <div className="d-flex" style={{ marginTop: "-87px" }}>
          <div
            style={{ display: "flex", flexDirection: "column", flex: 0.9 }}
          >
            <img
              src="/assets/img/BHA_1093.webp"
              alt="Restaurant"
              style={{ width: "100%", height: "150px", display: "block" }}
            />
            <img
              src="/assets/img/BHA_0930-.webp"
              alt="Swimming Pool"
              style={{ width: "100%", height: "150px", display: "block" }}
            />
          </div>

          {/* Right Column (big image) */}
          <div style={{ flex: 1.1 }}>
            <img
              src="/assets/img/BHA_0798.webp"
              alt="Hotel Room"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block"
              }}
            />
          </div>
        </div>

        {/* TERMS & CONDITIONS + PLACES TO EXPLORE */}
        <div className="p-4 mt-1">
          <div className="row">
            {/* Terms & Conditions */}
            <div className="col-md-6">
              <div> <h5 className="fw-bold mb-2" style={{ color: "#9b5c0d" }}>TERMS & CONDITIONS</h5>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container ">
                    <div className="bullet-dote-box"></div>
                  </div>
                  Check-in: 1400 hrs; Check-out: 1200 hrs.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Early check-in and late check-out subject to availability; applicable charges as per policy.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>ForgGuaranteed early check-in/late check-out, advance payment is required.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Cancellations must be made at least 48 hrs prior to arrival.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Failure to cancel on time or no-show will attract one-day retention charges.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>All guest must present valid goverment-approved photo ID(Aadhar, Driving License, voter ID, Passport).PAN card is not accepted as ID</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Foreign nationals must present valid password and visa.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Local guests & unmarried couples not allowed as per hotel policy.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Room tariff is per room er night; taxes and service charges extra.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Transfers not included but can arranged on a chargeable basis</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>All bills must be settled directly at check-out.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Special request are not guaranteed.</div>
                <div className="d-flex gap-2 p-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>Signing facility only for approved corporate account.</div>

              </div>
            </div>




            <div className="col-md-1"></div>

            {/* Places to Explore */}
            <div className="col-md-5">
              <h5 className="fw-bold mb-2" style={{ color: "#9b5c0d" }}>
                PLACES TO EXPLORE
              </h5>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">
                  <div>Dandi Beach</div></div>
                <div className="col-sm-3">
                  <div>23.9 KM</div></div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">National Salt Satyagrah Memorial</div>
                <div className="col-sm-3">25.6 KM</div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">First Dastoor Meherjirana Library</div>
                <div className="col-sm-3">8.6 KM</div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">Desai Atash Behram</div>
                <div className="col-sm-3">8.7 KM</div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">Jamshed Baug Navsari</div>
                <div className="col-sm-3">7.5 KM</div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">BAPS Shri Swaminarayan Temple</div>
                <div className="col-sm-3">9.1 KM</div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">Andheshwar Mahadev Temple</div>
                <div className="col-sm-3">10.7 KM</div>
              </div>
              <div className="row p-1">
                <div className="col-sm-1">
                  <div className="bullet-dote-container">
                    <div className="bullet-dote-box"></div>
                  </div>
                </div>
                <div className="col-sm-8">Unai Mata Temple</div>
                <div className="col-sm-3">55.7 KM</div>
              </div>

              <img
                src="/assets/img/examples/example11.jpeg"
                alt="Places to Explore"
                className="mt-4"
                style={{ width: "100%", height: "200px", objectFit: "cover" }}
              />
            </div>

          </div>

          <div className="text-center p-2">
            <img src="/assets/img/pdf Logo.png" alt="/" />
          </div>

          {/* DINING INFO */}

          <div >
            Dine at <strong>Gulmohar</strong>, our all-day buffet-style vegetarian restaurant,
            offering fresh delicacies,
            <br />Jain selections and chef’s specials daily.
            Or savour <strong>Gourmet Street</strong>, featuring flavourful street-food delights.
          </div>


          {/* OFFERS */}

          <h5 className=" fw-bold mt-3 mb-2" style={{ color: "#9b5c0d" }}>EXPLORE OUR OFFERS</h5>
          <h5 className="fw-bold" style={{ color: "#9b5c0d" }}>DIWALI GATEWAY 2025</h5>
          <div className="text-sm mt-1">
            Experience our <strong>Diwali Getaway</strong> at ₹29,999/- from 19 to 26 Oct 2025.
            Includes buffet meals, cocktails, 20% dining discount, vibrant DJ nights,
            and complimentary game round for two. Savour an extra lunch at Glumohar,our elegant
            all-day vegetarian restaurant, for ₹999++.
          </div>
        </div>

        {/* FOOTER */}

        <hr />
        <div className=" text-center">
          <div>
            {hotel.Address || "N/A"}
          </div>
          <div>
            Phone: {hotel.HotelPhone} | {hotel.HotelMobile} | Email: {hotel.HotelEmail}
          </div>
        </div>
      </div>
    </>
  )
}

